import {
  acceptCompletion,
  Completion,
  closeCompletion,
  selectedCompletion,
} from "@codemirror/autocomplete";
import { EditorView } from "@codemirror/view";

/**
 * A completion that is rendered invisibly and only serves to open the popup so
 * that the "Test run to see more suggestions" hint can be attached to it.
 */
export const HIDDEN_AUTOCOMPLETION_SUGGESTION_ID = "hidden" as const;
export const HIDDEN_AUTOCOMPLETION_SUGGESTION_CLASSNAME =
  "hidden-completion-mrP2X8" as const;

export const isHiddenCompletion = (completion: Completion | null): boolean =>
  completion?.label === HIDDEN_AUTOCOMPLETION_SUGGESTION_ID &&
  completion?.detail === HIDDEN_AUTOCOMPLETION_SUGGESTION_ID;

/**
 * The hidden completion carries no text to insert, so accepting it consumes the
 * key press without changing anything. Leaving the key unhandled instead keeps
 * its default meaning: moving focus to the next field, or indenting inside a
 * code editor.
 */
export const acceptCompletionUnlessHidden = (view: EditorView): boolean => {
  if (isHiddenCompletion(selectedCompletion(view.state))) {
    closeCompletion(view);
    return false;
  }
  return acceptCompletion(view);
};
